export { default } from "./PostQuote";
